import styled from 'styled-components/macro';
import {
  DefaultText,
  OrderActionAdditionalInfoText,
  OrderActionSubtitleText,
  OrderActionTitleText,
} from '../../common/fontElements';
import { PolicyDescription } from '../../common/policyStyles';
import { baseText, formInputTextForFilledBack } from '../../common/colorConstants';

// Wrapper
export const OrderTaskWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    margin: 10px 0;
  }

  padding: 0 20px;
`;

// Title
export const OrderTaskTitle = styled(OrderActionTitleText)`
  text-align: left;
`;

export const OrderTaskDescription = styled(OrderActionSubtitleText)`
  text-align: left;
`;

// Controls row
export const OrderTaskControls = styled.div`
  min-height: 48px;
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;

export const PolicyDescriptionError = styled(PolicyDescription)`
  color: ${(props) => (props.isError ? '#ff4d44' : '#333')};
`;

export const Divider = styled.div`
  width: calc(100% + 16px);
  height: 1px;
  margin-left: -8px;
  margin-right: -8px;

  background-color: #d8e8ef;
`;

export const CancelStep = styled.div`
  padding: 10px 0;
`;

export const StepTitle = styled(OrderActionAdditionalInfoText)`
  padding: 10px 0;
  font-size: 12px;
`;

export const Subtext = styled.span`
  opacity: 0.9;
  color: #7f7f7f;
`;

export const Required = styled.label`
  color: #ff4d44;
  font-family: 'Lato-Light', sans-serif;
  font-weight: normal;
  :before {
    content: '*';
  }
`;

export const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
`;

export const Checkbox = styled.input`
  margin: 5px !important;
`;

export const CheckboxHidden = styled.input`
  visibility: hidden !important;
  margin: 5px !important;
`;

export const RowContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;

  flex: 1 1;
`;

export const TrackingContent = styled(RowContent)`
  padding: 0 0;
`;

export const ItemDetail = styled(DefaultText)`
  color: ${baseText};
  opacity: ${({ active }) => (active ? '1' : '0.8')};
`;

export const ItemDetailWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SelectWrapper = styled.div`
  margin-right: 20px;
`;

export const RefundCommentTextarea = styled.textarea`
  flex: 2 1;

  min-height: 120px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.3;
  padding: 5px;

  color: ${formInputTextForFilledBack};
  border: 1px solid #4697c3;
  background-color: #f8fafc;
`;

export const FlexPlaceholder = styled.div`
  flex: 1 10;
`;

export const OrderSummaryBox = styled.div`
  flex: 1 1;
  flex-direction: column;
`;

export const OrderSummaryHeader = styled.div`
  font-size: 11px;
  font-family: Lato-Bold, sans-serif;

  color: #1c6774;

  padding: 8px;
`;
export const ErrorBlock = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  color: #ff4d44;
  text-align: center;
`;

export const OrderSummaryInfo = styled.div`
  font-size: 9px;

  color: #1c6774;
  background-color: #f8fafc;

  border-radius: 3px;
  padding: 8px;
`;

export const OrderSubtotalInfo = styled.div`
  font-size: 9px;
  font-family: Lato-Bold, sans-serif;
`;

export const Label = styled.label`
  opacity: 0.9;
  color: #7f7f7f;
  font-size: 1.2rem;
`;

export const LoadingBlock = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Input = styled.input`
  border-radius: 3px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.3;
  padding: 5px;
  min-width: 200px;

  color: ${formInputTextForFilledBack};
  border: 1px solid #4697c3;
  background-color: #f8fafc;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  display: flex;
`;
